"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var contentPageBaseTheme = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
    var MAX_M = _a.MAX_M, MAX_L = _a.MAX_L, MAX_S = _a.MAX_S, MAX_XS = _a.MAX_XS, MIN_M = _a.MIN_M, MIN_S = _a.MIN_S, MEDIA_PRINT = _a.MEDIA_PRINT;
    return ({
        contentPageTocHeader: (_b = {
                display: "flex",
                alignItems: "center",
                alignContent: "center",
                padding: "0",
                borderBottom: "1px solid #bdbdbd"
            },
            _b[MAX_M] = {
                padding: "0 1rem",
                display: "flex"
            },
            _b["& .material-icons.close"] = (_c = {
                    display: "none"
                },
                _c[MAX_M] = {
                    display: "block"
                },
                _c),
            _b),
        contentPageTocHeaderContainer: {
            alignItems: "center",
            width: "100%",
            display: "flex"
        },
        contentPageToc: {
            height: "100%",
            overflowY: "auto",
        },
        contentPageTocContainer: (_d = {
                display: "flex",
                flexDirection: "column",
                flexShrink: "0",
                marginRight: "0",
                height: 0,
                minHeight: "100%",
                paddingRight: "1rem",
                position: "relative"
            },
            _d[MAX_L] = {},
            _d[MAX_M] = {
                position: "absolute",
                minHeight: "0",
                paddingRight: "0",
            },
            _d[MEDIA_PRINT] = {
                display: "none",
            },
            _d["& > .mui-paper_root"] = (_e = {
                    borderRight: "none",
                    position: "absolute",
                    right: "0"
                },
                _e[MAX_M] = {
                    borderRight: "1px solid rgba(0, 0, 0, 0.12)",
                    position: "fixed",
                    width: "80vw",
                    minWidth: "0"
                },
                _e),
            _d),
        contentPageTocSearch: {
            transition: '0.2s ease-in-out',
            width: '2rem',
            '&:hover': {
                width: "100%",
            }
        },
        contentPageTocSearchWrapper: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'row-reverse'
        },
        contentPageTocSearchExpand: {
            width: "100%"
        },
        contentPageTocSearchInvalid: {
            backgroundColor: "rgba(255, 255, 0, 0.3)"
        },
        contentPageSiteSectionTitle: (_f = {
                fontSize: "1.25rem",
                marginLeft: "0.5rem",
                textTransform: 'capitalize',
                flex: 1
            },
            _f[MAX_S] = {
                fontSize: "1rem",
                textAlign: "left",
                fontWeight: "bolder",
            },
            _f),
        contentPageSiteSectionIcon: (_g = {
                width: "30px",
                height: "30px",
                display: "flex",
                alignSelf: "center",
                justifySelf: "center",
                "&> img": {
                    height: "100%",
                }
            },
            _g[MAX_S] = {
                marginTop: "1rem",
            },
            _g[MAX_XS] = {
                marginTop: "0.5rem",
                width: "30px",
                height: "30px",
            },
            _g),
        contentPageTocSubtitle: (_h = {
                display: "none",
                whiteSpace: "inherit",
                fontSize: "inherit",
                fontWeight: "inherit"
            },
            _h[MAX_M] = {
                display: "inline-block"
            },
            _h),
        contentPageTocTitle: (_j = {
                flex: 1,
                boxSizing: "border-box",
                padding: "0.5rem",
                marginLeft: "2rem",
                fontSize: "1.125rem",
                textTransform: "capitalize"
            },
            _j[MAX_M] = {
                whiteSpace: "nowrap",
                display: "flex",
                alignItems: "center",
                marginLeft: "0.5rem",
                padding: "0"
            },
            _j[MAX_S] = {
                padding: "1rem 0",
                marginLeft: "0"
            },
            _j[MAX_XS] = {
                fontSize: "0.875rem"
            },
            _j),
        contentPageBottomStepLinks: (_k = {},
            _k[MAX_S] = {
                display: "none"
            },
            _k[MIN_S] = {
                borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            },
            _k),
        contentPageDrawer: {},
        contentPagePrintButton: (_l = {},
            _l[MAX_S] = {
                display: "none"
            },
            _l),
        contentPageChunkedSectionsHeader: {
            display: "flex",
            alignItems: "center",
        },
        contentPageChunkedSectionsCloseIcon: (_m = {},
            _m[MIN_M] = {
                display: "none !important",
            },
            _m),
        contentPageChunkedSectionsWrapper: (_o = {
                position: "relative",
                zIndex: "3"
            },
            _o[MAX_M] = {
                position: "absolute",
            },
            _o),
        contentPageChunkedSections: {
            flex: "1",
            "& ul": {
                display: "block"
            },
            "& > .mui-paper_root": (_p = {
                    position: "absolute",
                    borderRight: "none",
                    minWidth: "100%"
                },
                _p[MAX_M] = {
                    padding: "0.5rem",
                    position: "fixed",
                    minWidth: "0",
                },
                _p)
        },
        contentPageNavBar: {},
        contentPageDrawerClose: (_q = {},
            _q[MIN_M] = {
                visibility: "visible !important",
                transform: "none !important"
            },
            _q),
        contentPageMainRendered: {},
        contentPageMainRenderedMissing: {
            display: "none"
        },
        contentPageHeaderBreadcrumb: (_r = {
                flex: 1,
                alignItems: "center"
            },
            _r[MAX_M] = {
                alignItems: "flex-start",
                width: "100%"
            },
            _r[MAX_S] = {
                "& nav": {
                    display: "none"
                }
            },
            _r),
        contentPageMain: (_s = {},
            _s[MAX_M] = {
                marginTop: "2rem"
            },
            _s[MAX_S] = {
                padding: "0 1rem",
                marginTop: "0"
            },
            _s.display = "grid",
            _s["&.has-chunked"] = (_t = {},
                _t[MIN_M] = {
                    gridTemplateColumns: "75% 25%"
                },
                _t),
            _s),
        contentPageMainHeader: (_u = {},
            _u[MIN_M] = {
                alignItems: "center",
                display: "flex"
            },
            _u[MAX_M] = {
                alignItems: "flex-start",
                flexDirection: "column"
            },
            _u),
        contentPageShareButton: (_v = {
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end"
            },
            _v[MAX_M] = {},
            _v[MAX_S] = {},
            _v),
        contentPageMainContainer: (_w = {},
            _w[MIN_S] = {
                minHeight: '50vh',
            },
            _w[MAX_M] = {
                minHeight: "auto"
            },
            _w),
        contentPageMainWrapper: {
            display: "flex",
            flex: 1,
            height: "auto",
            flexDirection: "column"
        },
        contentPageSiteSectionIconWrapper: (_x = {
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                margin: "1rem 0"
            },
            _x[MAX_M] = {
                display: "none",
            },
            _x),
        contentPageContainer: (_y = {
                display: "grid",
                gridTemplateColumns: "315px auto",
                gridAutoRows: "minmax(60vh, min-content)",
                flex: 1,
                width: "100%",
                height: "100%"
            },
            _y[MAX_L] = {},
            _y[MAX_M] = {
                display: "flex",
                flexDirection: "column",
                // gridTemplateColumns: "100%",
                padding: "0",
                // padding: "0.5rem 0.5rem 0.5rem 1rem",
                marginTop: "0"
                // marginTop: "0.5rem"
            },
            _y[MAX_XS] = {},
            _y)
    });
};
exports.default = contentPageBaseTheme;
//# sourceMappingURL=contentPage.js.map